<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 shape-default shape-skew response bg-gradient">
        </div>
        <div v-if="lawyer != null" class="pt-lg-md ml-auto mr-auto"
             style="width: 75%; padding: 0 100px 0 100px; margin-top: 150px">
            <div class="row justify-content-center">
                <v-card style="display: flex; flex-direction: column; width: 100%" class="p-4">
                    <div class="target-lawyer" style="width: 100%">
                        <div class="DoctorBox">
                            <div>
                                <div class="avatarDoctor">
                                    <div class="imageAvatar">
                                        <img :src="lawyer.lawyer_cover != null ? lawyer.lawyer_cover :
                                 require('@/assets/image/user_avatar.png')"/>
                                    </div>
                                </div>
                                <div class="titleDrPage">
                                    <h3>{{ lawyer.lawyer_title }}</h3>
                                    <div class="doctor_description text-center">
                                        <span v-if="lawyer.lawyer_verified">{{language.lang('Licence Verified')}}<i
                                                style="color: mediumseagreen"
                                                :class="'fa fa-check-circle ' + (isEN ? 'mr-3 ml-1' : 'ml-3 mr-1')"></i></span>
                                        <span class="font-weight-bold mr-auto ml-auto text-center">{{ lawyer.lawyer_brief }}</span>
                                        <div style="align-items: center"
                                             class="d-flex flex-row align-content-center ml-auto mr-auto mt-2">
                                            <i style="color: gold"
                                               :class="'fa fa-star display-4 ' + (isEN? 'mr-3 ml-auto' : 'ml-3 mr-auto')"></i>
                                            <span class="font-weight-bold" :class="isEN ? 'mr-auto' : 'ml-auto'">{{language.lang('rate: ') + lawyer.lawyer_rate + "   |   "  + oracle.format(lawyer.lawyer_voters) + language.lang(' vote(s)')}}</span>
                                        </div>
                                    </div>
                                    <div v-if="lawyer.lawyer_contact_public != null"
                                         class="row mt-3 mb-3 mr-auto ml-auto text-default">
                                        <div class="ml-auto"></div>
                                        <i @click="oracle.newTab(lawyer.lawyer_contact_public.facebook)"
                                           v-if="!oracle.isEmpty(lawyer.lawyer_contact_public.facebook)"
                                           style="width: 25px; height: 25px; font-size: 20px"
                                           class="m-1 fa fa-facebook badge-circle"></i>
                                        <i @click="oracle.newTab(lawyer.lawyer_contact_public.twitter)"
                                           v-if="!oracle.isEmpty(lawyer.lawyer_contact_public.twitter)"
                                           style="width: 25px; height: 25px; font-size: 20px"
                                           class="m-1 fa fa-twitter badge-circle"></i>
                                        <i @click="oracle.newTab(lawyer.lawyer_contact_public.instagram)"
                                           v-if="!oracle.isEmpty(lawyer.lawyer_contact_public.instagram)"
                                           style="width: 25px; height: 25px; font-size: 20px"
                                           class="m-1 fa fa-instagram badge-circle "></i>
                                        <i @click="oracle.newTab(lawyer.lawyer_contact_public.youtube)"
                                           v-if="!oracle.isEmpty(lawyer.lawyer_contact_public.youtube)"
                                           style="width: 25px; height: 25px; font-size: 20px; "
                                           class="m-1 fa fa-youtube badge-circle "></i>
                                        <div class="mr-auto"></div>
                                    </div>
                                    <div style="width: 70%">
                                        <v-tabs :style="isEN ? 'flex-direction: row-reverse !important' : ''"
                                                v-model="tabs"
                                                fixed-tabs color="gray" style="font-size: 11px; font-weight: bold">
                                            <v-tab
                                                    style="font-size: 11px; font-weight: bold"
                                                    v-for="n in items"
                                                    :key="n">
                                                {{ n }}
                                            </v-tab>
                                        </v-tabs>
                                    </div>
                                </div>
                                <div style="position: absolute; top: 0">
                                    <div style="width: auto; height: auto; display: flex; flex-direction: column; ">
                                        <base-button
                                                v-if="!showContact && !oracle.isEmpty(lawyer.lawyer_contact_private)"
                                                tag="span"
                                                @click="contactAction()"
                                                class="m-3"
                                                style="text-align: left !important; direction: ltr"
                                                type="default"
                                                icon="fa fa-phone">
                                            {{language.lang("Let's chat")}}
                                        </base-button>
                                        <base-button
                                                v-if="showContact && !oracle.isEmpty(lawyer.lawyer_contact_private.whatsapp)"
                                                tag="span"
                                                @click="redirectContact('whatsapp', lawyer.lawyer_contact_private.whatsapp)"
                                                class="mt-3 ml-3 mr-3 mb-1"
                                                type="default"
                                                style="background-color: #25D366; border-color: white; text-align: left !important; direction: ltr"
                                                icon="fa fa-whatsapp">
                                            Whatsapp
                                        </base-button>
                                        <base-button
                                                v-if="showContact && !oracle.isEmpty(lawyer.lawyer_contact_private.whatsapp)"
                                                tag="span"
                                                @click="redirectContact('call', lawyer.lawyer_contact_private.whatsapp)"
                                                class="mt-3 ml-3 mr-3 mb-1"
                                                type="default"
                                                style="background-color: #e45e5e; border-color: white; text-align: left !important; direction: ltr"
                                                icon="fa fa-phone">
                                            {{!isCall ? "Call" : lawyer.lawyer_contact_private.whatsapp}}
                                        </base-button>
                                        <base-button
                                                v-if="showContact && !oracle.isEmpty(lawyer.lawyer_contact_private.skype)"
                                                tag="span"
                                                @click="redirectContact('skype', lawyer.lawyer_contact_private.skype)"
                                                class="mt-1 ml-3 mr-3 mb-1"
                                                type="default"
                                                style="background-color: #00aff0; border-color: white; text-align: left !important; direction: ltr"
                                                icon="fa fa-skype">
                                            Skype
                                        </base-button>
                                        <base-button
                                                v-if="showContact && !oracle.isEmpty(lawyer.lawyer_contact_private.telegram)"
                                                tag="span"
                                                @click="redirectContact('telegram', lawyer.lawyer_contact_private.telegram)"
                                                class="mt-1 ml-3 mr-3 mb-1"
                                                type="default"
                                                style="background-color: #229ED9; border-color: white; text-align: left !important; direction: ltr"
                                                icon="fa fa-telegram">
                                            Telegram
                                        </base-button>
                                        <base-button
                                                v-if="showContact && !oracle.isEmpty(lawyer.lawyer_contact_private.discord)"
                                                tag="span"
                                                @click="redirectContact('discord', lawyer.lawyer_contact_private.discord)"
                                                class="mt-1 ml-3 mr-3 mb-1"
                                                type="default"
                                                style="background-color: #5865F2; border-color: white; text-align: left !important; direction: ltr"
                                                icon="fa fa-circle">
                                            Discord
                                        </base-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <v-tabs-items style="margin-top: -55px" v-model="tabs">
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <Overview :lawyer="lawyer"></Overview>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <Prices :is-lawyer="false" :lawyer="lawyer"></Prices>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <Reviews :lawyer="lawyer"></Reviews>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <Info :lawyer="lawyer"></Info>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                    <carousel v-if="comments != null && comments.length > 0" :dots="true"
                              :autoplay="true"
                              :autoWidth="true" :autoHeight="true"
                              :nav="false">
                        <div v-for="(item, index) in comments" :key="index">
                            <card style="width: 400px" shadow
                                  class="shadow-lg--hover mt-5 mb-5 ml-2 mr-2">
                                <div :class="'flex-column ' + (isEN ? 'text-left' : 'text-right')">
                                    <icon name="ni ni-satisfied" gradient="success" color="white" shadow
                                          rounded></icon>
                                    <h5 class="title text-success mt-3">{{item.name}}</h5>
                                    <p>{{item.text}}</p>
                                </div>
                            </card>
                        </div>
                    </carousel>
                    <p v-if="title != null && description != null" class="font-weight-bold mt-5">
                        {{language.lang('Share on social media:')}}
                        <ShareNetwork
                                :title="title"
                                :description="description"
                                network="facebook"
                                :url="currentPath"
                        >
                            <i class="fa fa-facebook m-2"></i>
                        </ShareNetwork>
                        <ShareNetwork
                                :title="title"
                                :description="description"
                                network="twitter"
                                :url="currentPath"
                        >
                            <i class="fa fa-twitter m-2"></i>
                        </ShareNetwork>
                        <ShareNetwork
                                :title="title"
                                :description="description"
                                network="telegram"
                                :url="currentPath"
                        >
                            <i class="fa fa-telegram m-2"></i>
                        </ShareNetwork>
                        <ShareNetwork
                                :title="title"
                                :description="description"
                                network="linkedin"
                                :url="currentPath"
                        >
                            <i class="fa fa-linkedin m-2"></i>
                        </ShareNetwork>
                        <ShareNetwork
                                :title="title"
                                :description="description"
                                network="whatsapp"
                                :url="currentPath"
                        >
                            <i class="fa fa-whatsapp m-2"></i>
                        </ShareNetwork>
                        <ShareNetwork
                                :title="title"
                                :description="description"
                                network="instapaper"
                                :url="currentPath"
                        >
                            <i class="fa fa-instagram m-2"></i>
                        </ShareNetwork>
                    </p>
                </v-card>
            </div>
        </div>
        <v-dialog style="box-shadow: none" width="100%" v-model="showRegister" transition="scroll-y-transition">
            <div :class="(isEN ? 'dir' : 'dirFa')" style="background-color: transparent;">
                <div style="display: flex; flex-direction: column; align-items: center; justify-items: center">
                    <RegisterComponent :close="true" :lambda-close="()=>{this.showRegister = false}"
                                       :lambda-done="()=>{this.showRegister = false, this.showContact = true}"
                                       :hint="'For get in touch with this lawyer please fill this form'">
                    </RegisterComponent>
                </div>
            </div>
        </v-dialog>
    </section>
</template>
<script>
    import oracle from "@/utils/oracle";
    import carousel from 'vue-owl-carousel'
    import language from "@/utils/language";
    import RegisterComponent from "@/views/profile/Authenticator";
    import Overview from "@/views/lawyer/Overview";
    import Reviews from "@/views/lawyer/Reviews";
    import Prices from "@/views/lawyer/Prices";
    import Info from "@/views/lawyer/Info";

    export default {
        name: "lawyer",
        data() {
            return {
                isCall: false,
                showRegister: false,
                showContact: false,
                title: null,
                description: null,
                lawyer: null,
                oracle: oracle,
                isEN: oracle.isEN(),
                rating: 5,
                currentPath: null,
                comments: [],
                shareText: "",
                language: language,
                tabs: null,
                items: [
                    language.lang('Overview'),
                    language.lang('Prices'),
                    language.lang('Reviews'),
                    language.lang('Info'),
                ],
            };
        },
        components: {Info, Overview, RegisterComponent, carousel, Reviews, Prices},
        methods: {
            redirectContact(type, link) {
                oracle.axios('lawyer/logContact', {"lawyer_id": this.lawyer.lawyer_id, "contact_base": type}, (res) => {
                    switch (type) {
                        case 'telegram':
                            oracle.newTab('https://t.me/' + link)
                            break
                        case 'call':
                            this.isCall = true
                            oracle.newTab('tel:+' + link)
                            break
                        case 'whatsapp':
                            oracle.saveToClipboard(link)
                            oracle.showMessage(language.lang("The consultant's number is saved in your clipboard.\nIf WhatsApp does not open, please first save the number to your contact and then connect with them via WhatsApp.") + "<br><br>" + language.lang("Consultant's Whatsapp number: ") + "<br>" + link, language.lang("I realized"), () => {
                            }, "checked")
                            oracle.newTab('https://api.whatsapp.com/send/?phone=' + link + '&text=' + this.shareText)
                            break
                        case 'discord':
                            oracle.newTab('https://discordapp.com/users/' + link)
                            break
                        case 'skype':
                            oracle.newTab('skype:' + link + '?chat')
                            break
                    }
                }, (res) => {
                    let support = '+16478730215'
                    oracle.saveToClipboard(support)
                    oracle.showMessage(language.lang("The support's number is saved in your clipboard.\nIf WhatsApp does not open, please first save the number to your contact and then connect with them via WhatsApp.") + "<br><br>" + language.lang("Support's Whatsapp number: ") + "<br>" + support, language.lang("I realized"), () => {
                    }, "checked")
                    oracle.newTab('https://api.whatsapp.com/send/?phone=' + support + '&text=' + this.shareText + " (Consultant: " + this.lawyer.lawyer_title + ")")
                })
            },
            contactAction() {
                if (oracle.isLoggedIn()) {
                    this.showContact = true
                } else {
                    this.showRegister = true
                }
            }
        },
        mounted() {
            this.currentPath = document.location.href
            let id = this.$route.params.id;
            let data = /\d/.test(id) ? {lawyer_id: id} : {index: id}
            oracle.axios("lawyer/get", data, (response) => {
                this.lawyer = response.data;
                this.title = this.lawyer.lawyer_title
                this.description = this.lawyer.lawyer_brief
                this.comments = this.lawyer.lawyer_comments
                document.title = 'Visternet | ' + this.title;
            });
            oracle.axios('setting/getInfo', {
                "filter_by": this.oracle.isEN() ? 'website_en' : 'website'
                , "search_by": "contact_share"
            }, (res) => {
                this.shareText = res.data
            })
        }
    };
</script>
<style>
    .target-lawyer {
        background-color: white;
    }

    .target-lawyer .box-Request-agent {
        height: 70vh;
        padding: 10px;
        border-radius: 10px !important;
        text-align: center;
        top: -70px;
    }

    .target-lawyer .box-Request-agent .v-sheet.v-card {
        border-radius: 25px !important;
    }

    .target-lawyer .box-Request-agent i {
        font-size: 70px !important;
        text-align: center;
    }

    .target-lawyer .box-Request-agent img {
        width: 100% !important;
        height: auto !important;
    }

    .target-lawyer .box-Request-agent p, .target-lawyer .box-Request-agent span,
    .target-lawyer .box-Request-agent a, .target-lawyer .box-Request-agent td,
    .target-lawyer .box-Request-agent th, .target-lawyer .box-Request-agent h1,
    .target-lawyer .box-Request-agent h2, .target-lawyer .box-Request-agent h3,
    .target-lawyer .box-Request-agent h4, .target-lawyer .box-Request-agent h5,
    .target-lawyer .box-Request-agent h6 {
        text-align: justify !important;
    }

    .target-lawyer .drPage {
        background: #fff;
    }

    .target-lawyer .on-chat {
        width: 15px;
        height: 15px;
        border-radius: 50px;
        position: absolute;
        background: #8bc34a;
        right: 10px;
        top: 5px;
    }

    .target-lawyer .modalChat,
    .target-lawyer .modalChats {
        padding: 20px 15px;
    }

    .target-lawyer .v-card__text {
        text-align: center;
    }

    .target-lawyer .headerDrPage {
        position: relative;
        height: 300px;
        width: 100%;
        background: #42C7D5;
        background: linear-gradient(
                180deg,
                #42C7D5,
                #ffffff
        );
        display: flex;
        justify-content: flex-end;
    }

    .target-lawyer .DoctorBox {
        width: 100%;
        height: auto;
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 0 3px 6px #00000029;
        z-index: 10;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        top: -95px;
    }

    .target-lawyer .logaccount button {
        color: #fff !important;
        font-size: 12px !important;
        padding: 5px 20px !important;
    }

    .target-lawyer .logaccount a button {
        display: flex !important;
        margin: 0 auto !important;
    }

    .target-lawyer .contentDrPage {
        /*padding: 130px 20px 0;*/
    }

    .target-lawyer .imageAvatar {
        text-align: center;
        width: 200px;
        height: 200px;
        border-radius: 100px;
        overflow: hidden;
        background: #fff;
        box-shadow: 0 3px 6px #00000029;
        border: 4px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .target-lawyer .imageAvatar img {
        text-align: center;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .target-lawyer .avatarDoctor {
        width: 200px;
        height: 200px;
        display: flex;
        justify-content: center;
        position: relative;
        margin: -60px auto 1.5em;
    }

    .target-lawyer .titleDrPage {
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
        flex-direction: column;
        align-items: center;
    }

    .target-lawyer .titleDrPage h3 {
        /*font-size: 17px;*/
        color: #427BD5;
        padding-bottom: 8px;
    }

    .target-lawyer .v-rating .v-icon {
        padding: 0;
    }

    .target-lawyer .titleDrPage span {
        /*font-size: 12px;*/
        color: #000;
        padding-bottom: 5px;
    }

    .target-lawyer .ConsultDoctor {
        display: flex;
        justify-content: flex-end;
        padding: 15px 0;
        background: #427BD5;
        height: 30px;
        border-top-left-radius: 40px;
        overflow: hidden;
        border-bottom-right-radius: 10px;
    }

    .target-lawyer .ConsultDoctor span {
        font-size: 15px;
        color: #fff;
        align-self: center;
        margin: 0 auto;
    }

    .target-lawyer .chatDoctor {
        background: #427BD5;
        width: 60px;
        height: 60px;
        border-radius: 50px;
        overflow: hidden;
        position: absolute;

        bottom: -30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .target-lawyer .chatDoctor .v-icon {
        color: #fff;
        font-size: 25px;
    }

    .target-lawyer .titlepackages {
        padding: 0 10px;
    }

    .target-lawyer .titlepackages,
    .target-lawyer .titleBoxs {
        border-right: 5px solid #427BD5;
        margin: 20px 15px;
    }

    .target-lawyer .titlepackages span {
        font-size: 12px;
        color: #646464;
    }

    .target-lawyer .sliderBoxs {
        display: flex;
        flex-wrap: nowrap;
        overflow: auto;
    }

    .target-lawyer .itemComment {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .target-lawyer ul {
        padding-left: 0 !important;
    }

    .target-lawyer .imageDrugs {
        width: 160px;
        height: 90px;
        margin-right: 5px;
    }

    .target-lawyer .imageDrugs img {
        width: 90%;
        height: 100%;
        object-fit: contain;
    }

    .target-lawyer .textBoxDrug p {
        color: #427BD5;
        font-size: 11px;
        padding-right: 5px;
        margin-bottom: 0;
    }

    .target-lawyer .textBoxDrug {
        /* display: flex !important; */
        padding-left: 10px;
        padding-top: 5px;
    }

    .target-lawyer .boxBlog {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .target-lawyer .dateBlog span {
        font-size: 12px;
        color: #707070;
    }

    .target-lawyer .itemBoxs {
        display: flex;
        padding: 5px 0;
    }

    .target-lawyer .coverimagUser {
        background: #fff;
        width: 65px;
        height: 65px;
        border-radius: 50%;
    }

    .target-lawyer .imageUser {
        width: 65px;
        height: 65px;
        border-radius: 50%;
        border: 3px solid #427BD5;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 3px 6px #00000029;
    }

    .target-lawyer .imageUser img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .target-lawyer .rateUser .v-icon {
        font-size: 18px;
    }

    .target-lawyer .textUser {
        display: flex;
    }

    .target-lawyer .commentsUser {
        display: flex;
        flex-direction: column;
        font-size: 13px;
        justify-content: center;
        padding: 10px 15px;
    }

    .target-lawyer .commentsUser span:first-child {
        font-weight: bold;
        color: #000;
    }

    .target-lawyer .titleUser {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .target-lawyer .dateComments {
        font-size: 12px;
        color: #707070;
    }

    .target-lawyer .boxUser {
        padding: 10px;
    }

    .target-lawyer .contetnDoctor {
        position: relative;
    }

    .target-lawyer .titleBoxs h4,
    .target-lawyer .titlepackages h4 {
        font-size: 14px;
        margin: 0 10px;
    }

    .target-lawyer .headlinemodalChat {
        display: flex;
        justify-content: space-between;
    }

    .target-lawyer .headlinemodalChat h5 {
        color: #000;
        font-size: 12px;
    }

    .target-lawyer .box-package-Dr {
        display: flex;
        justify-content: space-between;
        flex-direction: row !important;
        margin: 10px 15px;
        padding: 10px 15px;
        align-items: center;
    }

    .target-lawyer .img-package-Dr {
        width: 45px;
        height: 45px;
        margin-left: 8px;
    }

    .target-lawyer .img-package-Dr img {
        width: 100%;
        height: 100%;
    }

    .target-lawyer .title-package-Dr {
        display: flex;
        align-items: center;
    }

    .target-lawyer .text-package-Dr h4,
    .target-lawyer .price-package-Dr h4 {
        font-size: 14px;
    }

    .target-lawyer .text-package-Dr span,
    .target-lawyer .price-package-Dr span {
        color: #707070;
        font-size: 11px;
    }

    .target-lawyer .text-package-Dr {
        width: 60%;
    }

    .target-lawyer .headlinebuypackage {
        display: flex;
        justify-content: space-between;
    }

    .target-lawyer .headlinebuypackage h5 {
        color: #000;
        font-size: 14px;
    }

    .target-lawyer .removeFilterbuy span,
    .target-lawyer .removeFilters span {
        font-size: 12px;
        color: #707070;
    }

    .target-lawyer .removeFilterbuy .v-icon,
    .target-lawyer .removeFilters .v-icon {
        font-size: 15px;
        color: #707070;
    }

    .target-lawyer .content-dialog {
        color: #000;
        font-size: 12px;
        padding: 15px 0;
    }

    .target-lawyer .titlebuypackage,
    .target-lawyer .text-buypackage {
        display: flex;
        flex-direction: column;
        padding-top: 10px;
    }

    .target-lawyer .titlebuypackage h5,
    .target-lawyer .text-buypackage h5,
    .target-lawyer .price-pack h5,
    .target-lawyer .credit-me h5 {
        font-size: 14px;
        color: #707070;
    }

    .target-lawyer .titlebuypackage span,
    .target-lawyer .text-buypackage span,
    .target-lawyer .description-req label,
    .target-lawyer .price-pack span,
    .target-lawyer .credit-me span {
        font-size: 13px;
        color: #546467;
    }

    .target-lawyer .description-req {
        padding-top: 15px;
    }

    .target-lawyer .description-req .v-textarea {
        padding-top: 10px;
    }

    .target-lawyer .price-pack,
    .target-lawyer .credit-me {
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
    }

    .target-lawyer .price-pack span {
        color: #000;
        font-size: 15px;
    }

    .target-lawyer .credit-me {
        font-size: 14px;
    }

    .target-lawyer .btn-buy-doctor button {
        color: #fff !important;
        margin: 0 auto;
        display: flex;
    }

    .target-lawyer .boxbuypackage {
        padding: 15px 20px;
    }

    .target-lawyer .price-pack h5,
    .target-lawyer .credit-me h5 {
        font-weight: 100;
    }

    .target-lawyer .price-pack span,
    .target-lawyer .credit-me span {
        font-weight: bold;
    }

    .target-lawyer .credit-me {
        margin-bottom: 15px;
    }

    .target-lawyer .doctor_description {
        white-space: pre-wrap;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-top: 10px;
    }

    .target-lawyer .doctor_description p {
        font-size: 11px;
    }

    @media only screen and (max-width: 320px) {
        .target-lawyer .textBoxDrug p {
            font-size: 9px;
        }

        .target-lawyer .titleDrPage h3 {
            color: #427BD5 !important;
        }

        .target-lawyer .titleBoxs h4,
        .target-lawyer .titlepackages h4 {
            font-size: 12px;
        }

        .target-lawyer .rateUser .v-icon {
            font-size: 15px;
        }

        .target-lawyer .v-dialog > .v-card > .v-card__text .modalChats {
            font-size: 12px !important;
        }

        .target-lawyer .backbtn span {
            font-size: 12px;
        }

        .target-lawyer .titlepackages span {
            font-size: 10px;
        }

        .target-lawyer .imageDrugs {
            width: 110px;
            height: 60px;
        }

        .target-lawyer .avatarDoctor,
        .target-lawyer .imageAvatar {
            width: 75px;
            height: 75px;
        }

        .target-lawyer .avatarDoctor {
        }

        .target-lawyer .chatDoctor {
            width: 50px;
            height: 50px;
        }

        .target-lawyer .chatDoctor .v-icon {
            font-size: 20px;
        }
    }

    .target-lawyer .jcend-lawyer {
        padding-top: 5px;
        padding-bottom: 5px;
        justify-content: flex-end !important;
    }

    .target-lawyer .v-btn-back-lawyer {
        background-color: transparent !important;
        box-shadow: none;
        color: #000 !important;
    }

    .target-lawyer .conetenSupplement span {
        display: block;
        /*font-size: 11px;*/
        padding: 0 5px;
        font-family: Shabnam !important;
        line-height: 1.5;
    }

    .target-lawyer .conetenSupplement {
        padding: 10px 10px 10px 10px;
        margin-bottom: 50px;
    }

    .target-lawyer .conetenSupplement img {
        width: 100% !important;
        height: auto !important;
    }

    .target-lawyer .conetenSupplement p, .target-lawyer .conetenSupplement span, .target-lawyer .conetenSupplement a, .target-lawyer .conetenSupplement td, .target-lawyer .conetenSupplement th, .target-lawyer .conetenSupplement h1, .target-lawyer .conetenSupplement h2, .target-lawyer .conetenSupplement h3, .target-lawyer .conetenSupplement h4, .target-lawyer .conetenSupplement h5, .target-lawyer .conetenSupplement h6 {
        text-align: justify !important;
    }
</style>
